module.exports = "<div account-funnels-side-menu=\"\"></div><router-outlet></router-outlet>"